import React from 'react';
import Select from 'react-select';

/**
 * Searchable branch selector component with multi-select support
 * Uses react-select for search and multi-select functionality
 */
function BranchSelect({ value, onChange, branches, label = 'Chi nhánh', isMulti = true }) {
  // Convert branches to react-select format with "Tất cả" option
  const branchOptions = [
    { value: 'all', label: 'Tất cả' },
    ...branches.map(branch => ({
      value: branch,
      label: branch
    }))
  ];

  // For multi-select: value is array of branch names
  // For single-select: value is single branch name or 'all'
  let selectedOption;
  
  if (isMulti) {
    // Multi-select mode
    if (!value || value.length === 0) {
      selectedOption = []; // Empty selection
    } else if (value.includes('all')) {
      selectedOption = [branchOptions[0]]; // Show only "Tất cả" option
    } else {
      selectedOption = branchOptions.filter(opt => opt.value !== 'all' && value.includes(opt.value));
    }
  } else {
    // Single-select mode (legacy)
    selectedOption = branchOptions.find(opt => opt.value === value) || branchOptions[0];
  }

  // Custom styles to match Bootstrap theme
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? '#86b7fe' : '#dee2e6',
      boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
      '&:hover': {
        borderColor: '#86b7fe'
      },
      minHeight: '38px',
      fontSize: '1rem'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected 
        ? '#0d6efd' 
        : state.isFocused 
          ? '#e7f1ff' 
          : 'white',
      color: state.isSelected ? 'white' : '#212529',
      '&:active': {
        backgroundColor: '#0d6efd'
      }
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1000
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#6c757d'
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#212529'
    })
  };

  const handleChange = (selectedOptions) => {
    if (isMulti) {
      // Multi-select: return array of branch values
      if (!selectedOptions || selectedOptions.length === 0) {
        onChange([]); // Empty = show all data
      } else {
        const values = selectedOptions.map(opt => opt.value);
        // If "Tất cả" is selected, return ['all']
        if (values.includes('all')) {
          onChange(['all']);
        } else {
          onChange(values);
        }
      }
    } else {
      // Single-select
      onChange(selectedOptions.value);
    }
  };

  return (
    <div>
      {label && <label className="form-label fw-bold">{label}</label>}
      <Select
        value={selectedOption}
        onChange={handleChange}
        options={branchOptions}
        styles={customStyles}
        placeholder={isMulti ? "Chọn chi nhánh..." : "Chọn chi nhánh..."}
        isSearchable={true}
        isMulti={isMulti}
        noOptionsMessage={() => 'Không tìm thấy chi nhánh'}
        className="react-select-container"
        classNamePrefix="react-select"
        closeMenuOnSelect={!isMulti}
        isClearable={isMulti}
      />
      {isMulti && value && value.length > 0 && !value.includes('all') && (
        <small className="text-muted d-block mt-1">
          Đang hiển thị {value.length} / {branches.length} chi nhánh
        </small>
      )}
      {isMulti && (!value || value.length === 0 || value.includes('all')) && (
        <small className="text-muted d-block mt-1">
          <i className="bi bi-check-circle me-1"></i>
          Đang hiển thị tất cả {branches.length} chi nhánh
        </small>
      )}
    </div>
  );
}

export default BranchSelect;
